'use client';

import Image from 'next/image';
import { useIntl } from 'react-intl';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import appIconCircle from './app-icon-circle.svg';
import appIconSrc from './app-icon.svg';

type Props = {
  className?: string;
  size: number;
  shape?: 'circle' | 'square';
};

// https://www.figma.com/file/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?type=design&node-id=5003-58164&mode=dev
export default function AppIcon({ className, size, shape = 'square' }: Props) {
  const intl = useIntl();

  return (
    <Image
      {...setDenaliAttribute('AppIcon')}
      alt={intl.formatMessage({ defaultMessage: 'AllTrails logo' })}
      className={className}
      height={size}
      src={shape === 'square' ? appIconSrc : appIconCircle}
      width={size}
    />
  );
}
